import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CommonWebConfigService,
  AdminListConfigModel,
  ListConfigType
} from '../autogenerated';
import { REQUEST_OPTIONS } from '../constants';
import { RequestOptionsJsonType } from '../types';

@Injectable({ providedIn: 'root' })
export class CommonWebConfigApiService {
  constructor(private apiService: CommonWebConfigService) {}

  public getListConfiguration(listConfigType: ListConfigType, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminListConfigModel> {
    return this.apiService.adminConfigListGet(listConfigType, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public setListConfiguration(listConfigType: ListConfigType, adminListConfigModel: AdminListConfigModel, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminListConfigModel> {
    return this.apiService.adminConfigListSet(listConfigType, adminListConfigModel, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
